module.exports = __webpack_public_path__ + "assets/img/Abhijit-with-Madan.02948f8a.jpg";